module.exports = __webpack_public_path__ + "static/media/me.c07e64cc.png";